import { Play, X } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";

import type { Tutorial } from "../types";
import { TutorialPoster } from "./TutorialPoster";

type Props = {
  tutorial: Tutorial;
  onWatch: () => void;
  onLater: () => void;
};

/** The announcement for a new tutorial: a toast with its poster, Watch and Later. */
export const TutorialToastCard: FC<Props> = ({
  tutorial,
  onWatch,
  onLater
}) => (
  <div
    className="w-80 overflow-hidden rounded-xl bg-elevated text-fg shadow-popover ring-1 ring-line-3"
    data-testid="tutorial-toast"
  >
    <button
      type="button"
      onClick={onWatch}
      aria-label={`Watch ${tutorial.title}`}
      className="group/play block w-full cursor-pointer border-b border-line-1 outline-none"
    >
      <TutorialPoster tutorial={tutorial} />
    </button>
    <div className="flex flex-col gap-0.5 px-4 pt-3 pb-4">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium text-accent-seed">
          New Tutorial
        </span>
        <Button
          variant="ghost"
          size="icon-2xs"
          aria-label="Dismiss"
          onClick={onLater}
        >
          <X />
        </Button>
      </div>
      <span className="text-md font-medium">{tutorial.title}</span>
      <span className="text-sm text-fg-3">
        {Math.round(tutorial.durationSecs / 60)} min
        {tutorial.chapters.length
          ? ` · ${tutorial.chapters.length} chapters`
          : ""}
      </span>
      <div className="mt-3 flex items-center gap-1.5">
        <Button variant="primary" size="sm" onClick={onWatch}>
          <Play />
          Watch
        </Button>
        <Button variant="ghost" size="sm" onClick={onLater}>
          Later
        </Button>
      </div>
    </div>
  </div>
);
